// src/components/PromptManagerModal.js

import React, { useState } from 'react';
import { X, Trash2, Edit, Save } from 'lucide-react';

const PromptManagerModal = ({ isOpen, onClose, prompts, onUpdatePrompt, onDeletePrompt }) => {
  const [editingId, setEditingId] = useState(null);
  const [editText, setEditText] = useState({ name: '', prompt: '' });

  if (!isOpen) return null;

  const handleEdit = (prompt) => {
    setEditingId(prompt.id);
    setEditText({ name: prompt.name, prompt: prompt.prompt });
  };

  const handleCancel = () => {
    setEditingId(null);
    setEditText({ name: '', prompt: '' });
  };

  const handleSave = () => {
    onUpdatePrompt(editingId, editText.name, editText.prompt);
    handleCancel();
  };

  const handleDelete = (promptId, promptName) => {
    // Usamos un simple confirm para la seguridad.
    if (window.confirm(`¿Estás seguro de que quieres eliminar el prompt "${promptName}"?`)) {
      onDeletePrompt(promptId);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[80vh] flex flex-col">
        <div className="flex justify-between items-center p-4 border-b">
          <h2 className="text-xl font-bold text-gray-800">Administrar Prompts de IA</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-800">
            <X size={24} />
          </button>
        </div>
        
        <div className="p-6 overflow-y-auto">
          <div className="space-y-4">
            {(prompts || []).map(prompt => (
              <div key={prompt.id} className="p-3 border rounded-md transition-all">
                {editingId === prompt.id ? (
                  <div className="space-y-3">
                    {/* MEJORA: Labels para claridad en la edición */}
                    <div>
                        <label className="text-xs font-semibold text-gray-500">Nombre del Prompt</label>
                        <input
                          type="text"
                          value={editText.name}
                          onChange={(e) => setEditText(p => ({ ...p, name: e.target.value }))}
                          className="w-full p-2 border rounded-md font-semibold"
                        />
                    </div>
                    <div>
                        <label className="text-xs font-semibold text-gray-500">Contenido del Prompt</label>
                        <textarea
                          rows="4"
                          value={editText.prompt}
                          onChange={(e) => setEditText(p => ({ ...p, prompt: e.target.value }))}
                          className="w-full p-2 border rounded-md text-sm"
                        />
                    </div>
                    <div className="flex justify-end gap-2">
                      <button onClick={handleCancel} className="px-3 py-1 text-sm bg-gray-200 rounded-md hover:bg-gray-300">Cancelar</button>
                      <button onClick={handleSave} className="px-3 py-1 text-sm bg-blue-600 text-white rounded-md flex items-center gap-1 hover:bg-blue-700">
                        <Save size={14}/> Guardar
                      </button>
                    </div>
                  </div>
                ) : (
                  <div>
                    <h3 className="font-semibold text-gray-900">{prompt.name}</h3>
                    <p className="text-sm text-gray-600 mt-1 whitespace-pre-wrap">{prompt.prompt}</p>
                    <div className="flex justify-end gap-2 mt-2">
                      {/* MEJORA: Tooltips en los botones */}
                      <button onClick={() => handleDelete(prompt.id, prompt.name)} className="text-red-500 hover:text-red-700 p-1" title="Eliminar">
                        <Trash2 size={16} />
                      </button>
                      <button onClick={() => handleEdit(prompt)} className="text-blue-500 hover:text-blue-700 p-1" title="Editar">
                        <Edit size={16} />
                      </button>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PromptManagerModal;
